import { render } from "./ExploreMenuItems.vue?vue&type=template&id=3ef60370"
import script from "./ExploreMenuItems.vue?vue&type=script&lang=js"
export * from "./ExploreMenuItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__